export enum LanguageLabel {
  'ar' = 'العَرَبِية‎',
  'bg' = 'Български',
  'cz' = 'Český',
  'da' = 'Dansk',
  'de' = 'Deutsch',
  'el' = 'Ελληνικά',
  'gr' = 'Ελληνικά',
  'us' = 'USA - English',
  'en' = 'English',
  'es' = 'Español',
  'se' = 'USA - Español',
  'fi' = 'Suomi',
  'fr' = 'Français',
  'it' = 'Italiano',
  'ja' = '日本語',
  'jp' = '日本語',
  'ko' = '한국어',
  'nl' = 'Nederlands',
  'no' = 'Norsk',
  'pl' = 'Polski',
  'pt' = 'Português',
  'br' = 'Português',
  'ro' = 'Român',
  'ru' = 'Русский',
  'sv' = 'Svenska',
  'tr' = 'Türkçe',
  'cn' = '中文'
}
